import tokens from '@gjensidige/builders-tokens/dist/tokens-web.json';

export const configureChartJs = (ChartJS) => {
  ChartJS.defaults.font = { size: 16, family: tokens.font.sans };
  ChartJS.defaults.color = tokens.color.blue700;

  ChartJS.defaults.plugins.legend.position = 'bottom';
  ChartJS.defaults.plugins.legend.align = 'center';
  ChartJS.defaults.plugins.legend.labels.usePointStyle = true;
  ChartJS.defaults.plugins.legend.labels.pointStyle = 'circle';
  ChartJS.defaults.plugins.legend.labels.boxHeight = 11;
  ChartJS.defaults.plugins.legend.labels.padding = 20;
  ChartJS.defaults.plugins.legend.title = {
    display: true,
    padding: { top: 0, right: 0, left: 0, bottom: 10 },
    text: ''
  };

  ChartJS.defaults.plugins.tooltip.backgroundColor = tokens.color.white;
  ChartJS.defaults.plugins.tooltip.bodyColor = tokens.color.blue700;
  ChartJS.defaults.plugins.tooltip.bodyFont = {
    size: 16
  };
  ChartJS.defaults.plugins.tooltip.titleColor = tokens.color.blue700;
  ChartJS.defaults.plugins.tooltip.titleFont = {
    size: 16,
    family: tokens.font.display
  };
  ChartJS.defaults.plugins.tooltip.cornerRadius = 0;
  ChartJS.defaults.plugins.tooltip.borderColor = tokens.color.blue700;
  ChartJS.defaults.plugins.tooltip.borderWidth = 1;
  ChartJS.defaults.plugins.tooltip.displayColors = false;
  ChartJS.defaults.layout.padding = {
    left: 10,
    top: 20,
    right: 10,
    bottom: 0
  };

  ChartJS.overrides['doughnut'].plugins.legend.align = 'start';
  ChartJS.overrides['doughnut'].plugins.legend.onClick = (
    _e,
    _legendItem,
    legend
  ) => legend.chart.setActiveElements([{ datasetIndex: 0, index: 0 }]);
};
